import DiagnoseDoughnut from './_DiagnoseDoughnut';

export default DiagnoseDoughnut;
